import React, { useRef, useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  CssBaseline,
  Typography,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
  useTheme,
  useMediaQuery,
  Tooltip,
  Button,
  Avatar,
} from "@mui/material";
import { tokens } from "../components/Theme";
import MenuIcon from "@mui/icons-material/Menu";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LayersIcon from "@mui/icons-material/Layers";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import PersonIcon from "@mui/icons-material/Person";
import MapIcon from "@mui/icons-material/Map";
import ForestIcon from "@mui/icons-material/Forest";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import UserData from "../components/UserData";
import LandManage from "../components/LandManage";
import FeedIcon from "@mui/icons-material/Feed";
import StorefrontIcon from "@mui/icons-material/Storefront";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import FarmManage from "../components/FarmManage";
import CropGap from "../components/CropGAP";
import Community from "../components/Community";
import News from "../components/News";
import Market from "../components/Market";
import Merchant from "../components/Merchant";
import Appointment from "../components/Appointment";
import PhoneIcon from '@mui/icons-material/Phone';
import { useNavigate } from "react-router-dom";
import logom from "../img/logo-m.png";
import logof from "../img/logo-f.png";
const fullDrawerWidth = 240;
const collapsedDrawerWidth = 60;
const navigationItems = [
  { text: "ข้อมูลผู้ใช้", icon: <PersonIcon />, key: "user" },
  { text: "ที่อยู่ฟาร์ม", icon: <LayersIcon />, key: "farm" },
  { text: "ที่ดิน", icon: <MapIcon />, key: "land" },
  { text: "รอบการเพาะปลูก", icon: <ForestIcon />, key: "cycle" },
  {
    text: "การพูดคุย-สังคม",
    icon: <ConnectWithoutContactIcon />,
    key: "social",
  },
  { text: "ข่าวสาร", icon: <FeedIcon />, key: "news" },
  { text: "การตลาด", icon: <StorefrontIcon />, key: "market" },
  { text: "ผู้รับซื้อ", icon: <ShoppingCartIcon />, key: "buyer" },
  { text: "บินโดรนพ่นยา", icon: <FlightTakeoffIcon />, key: "que" },
  {
    text: "ติดต่อเรา",
    icon: <PhoneIcon />,
    key: "contact",
    external: true,
    href: "https://lin.ee/DmW6sJb",
  },
];

function Homepage() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [collapsed, setCollapsed] = React.useState(false);
  const [selectedMenu, setSelectedMenu] = useState("user");
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("userdata"));
  const [imgError, setImgError] = useState(false);

  const imageUrl = `${process.env.REACT_APP_STORAGE_URL}pea-daily/Farmer/${userData?.appFarmerId}.png`;

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };
  useEffect(() => {
    document.body.style.backgroundColor = "#F3F2F8";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  const handleDrawerToggle = () => {
    if (isMobile) {
      setMobileOpen(!mobileOpen);
    } else {
      setCollapsed(!collapsed);
    }
  };
  const drawerWidth = collapsed ? collapsedDrawerWidth : fullDrawerWidth;

  const drawer = (
    <Box>
      <Toolbar
        sx={{
          justifyContent: collapsed ? "center" : "space-between",
          px: 2,
        }}
      >
        {!collapsed && (
          <img src={logof} width={isMobile ? "80px" : "60px"} alt="logo" />
        )}
        <IconButton onClick={handleDrawerToggle}>
          {collapsed ? (
            <img src={logom} width={isMobile ? "20px" : "40px"} alt="logo" />
          ) : (
            <ChevronLeftIcon />
          )}
        </IconButton>
      </Toolbar>
      <Divider />
      <List>
        {navigationItems.map((item) => (
          <Tooltip
            title={collapsed ? item.text : ""}
            placement="right"
            key={item.text}
          >
            <ListItem
              button
              component="div"
              disableRipple
              onClick={() => setSelectedMenu(item.key)}
              selected={selectedMenu === item.key}
              sx={{
                backgroundColor:
                  selectedMenu === item.key ? colors.greenAccent[400] : "#fff",
                color: selectedMenu === item.key ? "#fff" : "",
                borderRadius: 1,
                mx: 1,
                my: 0.5,
                "&:hover": {
                  backgroundColor: colors.greenAccent[300],
                  color: "#fff",
                  "& .MuiListItemIcon-root": {
                    color: "#fff",
                  },
                },
                "&.Mui-selected": {
                  backgroundColor: colors.greenAccent[500],
                  color: "#fff",
                  "& .MuiListItemIcon-root": {
                    color: "#fff",
                  },
                  "&:hover": {
                    backgroundColor: colors.greenAccent[600],
                  },
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color:
                    selectedMenu === item.key
                      ? "#fff"
                      : colors.greenAccent[400],
                  minWidth: collapsed ? "auto" : undefined,
                  justifyContent: "center",
                }}
              >
                {item.icon}
              </ListItemIcon>
              {!collapsed && <ListItemText primary={item.text} />}
            </ListItem>
          </Tooltip>
        ))}
      </List>
    </Box>
  );

  const renderContent = () => {
    switch (selectedMenu) {
      case "user":
        return <UserData />;
      case "land":
        return <LandManage />;
      case "cycle":
        return <CropGap />;
      case "farm":
        return <FarmManage />;
      case "social":
        return <Community />;
      case "news":
        return <News />;
      case "market":
        return <Market />;
      case "buyer":
        return <Merchant />;
      case "que":
        return <Appointment />;
      case "contact":
           window.open("https://lin.ee/DmW6sJb", "_blank");
          return <Typography>กำลังเปลี่ยนทาง...</Typography>;
      default:
        return <Typography>กรุณาเลือกเมนู</Typography>;
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          ml: { sm: `${drawerWidth}px` },
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }}
      >
        <Toolbar
          sx={{
            backgroundColor: colors.greenAccent[400],
            justifyContent: "space-between",
          }}
        >
          <Box display="flex" alignItems="center">
            {isMobile && (
              <IconButton
                color="inherit"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
            )}
            <Typography variant="h6" display={isMobile ? "none" : ""}>
              ยินดีต้อนรับ เกษตรกร
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" gap={2}>
            <Avatar
              alt="User Avatar"
              src={!imgError ? imageUrl : "/default-avatar.png"} // fallback to local
              onError={() => setImgError(true)}
              sx={{ bgcolor: "primary.main", width: 40, height: 40 }}
            />
            <Button variant="outlined" onClick={handleLogout}>
              Logout
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="navigation drawer"
      >
        <Drawer
          variant={isMobile ? "temporary" : "permanent"}
          open={isMobile ? mobileOpen : true}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.standard,
              }),
              overflowX: "hidden",
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          mt: 8,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.standard,
          }),
        }}
      >
        {renderContent()}
      </Box>
    </Box>
  );
}

export default Homepage;
